var USER_PROFILE_REVIEW_URL = '/user/review';
var USER_PROFILE_REVIEW_ABOUT_CREATORS_URL = '/user/review/about-my-creators';
var REVIEW_ABOUT_ME_LOAD_URL = '/review/user/about-customer';
var REVIEW_ABOUT_MY_CREATORS_LOAD_URL = '/review/user/about-owner';
var REVIEW_REACTION_URL = '/review/default/reaction';
var USER_RPOFILE_REVIEW_LOAD_SUCCESS = 'USER_PROFILE_LOAD_SUCCESS';
var USER_PROFILE_REVIEW_DESTROY = 'USER_PROFILE_REVIEW_DESTROY';
var REVIEW_REACTION_SAVE_SUCCESS = 'REVIEW_REACTION_SAVE_SUCCESS';
var USER_PROFILE_REVIEW_TYPE_OWNER = 'owner';
var USER_PROFILE_REVIEW_TYPE_CUSTOMER = 'customer';
var REDUCER_USER_PROFILE_REVIEW_NAME = 'reducerUserReview';
export { USER_PROFILE_REVIEW_URL, USER_PROFILE_REVIEW_ABOUT_CREATORS_URL, REVIEW_ABOUT_ME_LOAD_URL, REVIEW_ABOUT_MY_CREATORS_LOAD_URL, REVIEW_REACTION_URL, USER_RPOFILE_REVIEW_LOAD_SUCCESS, USER_PROFILE_REVIEW_DESTROY, REVIEW_REACTION_SAVE_SUCCESS, USER_PROFILE_REVIEW_TYPE_OWNER, USER_PROFILE_REVIEW_TYPE_CUSTOMER, REDUCER_USER_PROFILE_REVIEW_NAME };